import type { I18nTextInputValue } from './I18nTextInput.tsx';
import { FormattedMessage } from 'react-intl';
import { LanguageCodes } from '@_/static';
import { formatLanguageName } from '@_/utils';

export function resolvePromptMessage(data: {
  languageCode: string;
  locale: string;
  value: I18nTextInputValue;
}) {
  const { languageCode, locale, value } = data;

  const otherLanguage = LanguageCodes.find(code => code !== languageCode);

  const missingCurrentLanguage = !value[languageCode]?.trim();
  const missingOtherLanguage = !!otherLanguage && !value[otherLanguage]?.trim();

  if (missingCurrentLanguage && missingOtherLanguage) {
    // Sort languages so the message phrasing is always consistent
    const [languageA, languageB] = [
      formatLanguageName(locale, languageCode),
      formatLanguageName(locale, otherLanguage)
    ].sort();

    return (
      <FormattedMessage
        id="component:prompt.fill-both-languages-to-reach-audience"
        defaultMessage="Add this in both {languageA} and {languageB} to reach a wider audience"
        values={{
          languageA,
          languageB
        }}
      />
    );
  }

  if (missingCurrentLanguage || missingOtherLanguage) {
    return (
      <FormattedMessage
        id="component:prompt.fill-other-language-to-reach-audience"
        defaultMessage="Add this in {language} to reach a wider audience"
        values={{
          language: formatLanguageName(locale, missingOtherLanguage ? otherLanguage : languageCode)
        }}
      />
    );
  }
}
